import { DARK_BLUE, GREY_BLUE } from '../theme/color';

export const overrides = {
    MuiLinearProgress: {
        barColorPrimary: {
            backgroundColor: DARK_BLUE
        },
        colorPrimary: {
            backgroundColor: GREY_BLUE,
            borderRadius: 3,
            height: 5
        }
    }
};
